<div class="signin-page" *ngIf="event">

  <!-- Toast notifications -->
  <div class="signin-toast signin-toast--success" *ngIf="toastSuccess" (click)="dismissToast()">
    {{ toastSuccess }}
  </div>
  <div class="signin-toast signin-toast--error" *ngIf="toastError" (click)="dismissToast()">
    {{ toastError }}
  </div>

  <!-- Company logo header -->
  <header class="signin-site-header" *ngIf="event.company?.image">
    <div class="page-wrapper">
      <img [src]="event.company.image"
           [alt]="event.company.name || 'Company Logo'"
           class="signin-company-logo" />
    </div>
  </header>

  <!-- Hero banner -->
  <div class="hero-image-placeholder">
    <div class="hero-overlay"></div>
  </div>

  <div class="page-wrapper">

    <!-- Event title + product badges -->
    <div class="event-title-row">
      <h1 class="event-title">{{ eventTitle }}</h1>
      <div *ngIf="topicProducts.length" class="event-product-badges">
        <img *ngFor="let product of topicProducts"
             [src]="product.image"
             [alt]="product.name"
             class="event-company-badge" />
      </div>
    </div>

    <div class="event-content-grid">

      <!-- Left column: greeting + event details -->
      <div class="event-col-left">
        <div class="rsvp-card">
          <p class="rsvp-text">Thank you for attending the presentation!</p>
          <p class="rsvp-subtext" *ngIf="!isEventConcluded">Please scroll below and select your name to sign in.</p>
          <p class="rsvp-subtext" *ngIf="isEventConcluded">This event has concluded. We appreciate your interest.</p>
        </div>

        <!-- Event Details card -->
        <section class="detail-section">
          <h2 class="section-title">Event Details</h2>

          <div class="detail-row" *ngIf="eventFriendlyDate">
            <div class="detail-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="currentColor"/></svg>
            </div>
            <div class="detail-content">
              <span class="detail-label">Event Date</span>
              <span class="detail-value">{{ eventFriendlyDate }} {{ eventStartTime }} {{ eventTimezoneShort }}</span>
            </div>
          </div>

          <div class="detail-row" *ngIf="eventTitle">
            <div class="detail-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z" fill="currentColor"/></svg>
            </div>
            <div class="detail-content">
              <span class="detail-label">Presentation</span>
              <span class="detail-value">{{ eventTitle }}</span>
            </div>
          </div>

          <div class="detail-row" *ngIf="meetingTypeName">
            <div class="detail-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" fill="currentColor"/></svg>
            </div>
            <div class="detail-content">
              <span class="detail-label">Meeting Type</span>
              <span class="detail-value">{{ meetingTypeName }}</span>
            </div>
          </div>

          <div class="location-block" *ngIf="event.venue">
            <div class="detail-row detail-row--no-border">
              <div class="detail-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" fill="currentColor"/></svg>
              </div>
              <div class="detail-content">
                <span class="detail-label">Location</span>
                <span class="detail-value">{{ event.venue.name }}</span>
                <span class="detail-subvalue" *ngIf="venueAddress">{{ venueAddress }}</span>
              </div>
              <a *ngIf="googleMapsUrl"
                 [href]="googleMapsUrl"
                 target="_blank"
                 rel="noopener"
                 class="detail-action"
                 aria-label="Open in Google Maps">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M19 19H5V5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" fill="currentColor"/></svg>
              </a>
            </div>

            <a *ngIf="staticMapUrl && !mapImageFailed"
               [href]="googleMapsUrl"
               target="_blank"
               rel="noopener"
               class="venue-map-container"
               aria-label="Open in Google Maps">
              <img [src]="staticMapUrl"
                   alt="Map showing venue location"
                   class="venue-map-image"
                   [style.transform]="mapImageTransform"
                   loading="lazy"
                   (error)="mapImageFailed = true" />
              <svg class="venue-map-pin" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg"
                   [style.left]="mapPinLeft"
                   style="top: 50%">
                <path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24S24 21 24 12C24 5.373 18.627 0 12 0z" fill="#e53935"/>
                <circle cx="12" cy="12" r="5" fill="white"/>
              </svg>
            </a>
          </div>

          <div class="detail-row" *ngIf="event.name">
            <div class="detail-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zm-5-4H7v-2h8v2zm2-4H7V8h10v2z" fill="currentColor"/></svg>
            </div>
            <div class="detail-content">
              <span class="detail-label">Event ID</span>
              <span class="detail-value">{{ event.name }}</span>
            </div>
          </div>
        </section>
      </div>

      <!-- Right column: People (or inline sign-in form) -->
      <div class="event-col-right" #peopleSection>

        <!-- ===== People view ===== -->
        <section class="detail-section" *ngIf="view === 'people'">
          <h2 class="section-title">People</h2>

          <!-- Speakers -->
          <ng-container *ngIf="confirmedSpeakers.length">
            <div class="people-subheader">Speaker</div>
            <ng-container *ngFor="let speaker of confirmedSpeakers; let last = last">
              <div class="person-card">
                <div class="person-photo-wrapper">
                  <img *ngIf="speaker.photo" [src]="speaker.photo" [alt]="fullSpeakerName(speaker)" class="person-photo" />
                  <div *ngIf="!speaker.photo" class="person-photo-placeholder">
                    {{ (speaker.first_name || '').charAt(0) }}{{ (speaker.last_name || '').charAt(0) }}
                  </div>
                </div>
                <div class="person-info">
                  <span class="person-name">{{ fullSpeakerName(speaker) }}</span>
                  <span class="person-title" *ngIf="speakerSublabel(speaker)">{{ speakerSublabel(speaker) }}</span>
                  <span class="person-role">Speaker</span>
                </div>
              </div>
              <hr *ngIf="!last" class="person-divider" />
            </ng-container>
          </ng-container>

          <!-- Reps (event.client is the rep assigned to the event) -->
          <ng-container *ngIf="reps.length">
            <hr *ngIf="confirmedSpeakers.length" class="person-divider" />
            <div class="people-subheader">Rep</div>
            <ng-container *ngFor="let rep of reps; let last = last">
              <div class="person-card">
                <div class="person-photo-wrapper">
                  <img *ngIf="rep.photo" [src]="rep.photo" [alt]="fullSpeakerName(rep)" class="person-photo" />
                  <div *ngIf="!rep.photo" class="person-photo-placeholder">
                    {{ (rep.first_name || '').charAt(0) }}{{ (rep.last_name || '').charAt(0) }}
                  </div>
                </div>
                <div class="person-info">
                  <span class="person-name">{{ fullSpeakerName(rep) }}</span>
                  <span class="person-title" *ngIf="rep.title">{{ rep.title }}</span>
                  <span class="person-role">Rep</span>
                </div>
              </div>
              <hr *ngIf="!last" class="person-divider" />
            </ng-container>
          </ng-container>

          <!-- Hosts -->
          <ng-container *ngIf="event.hosts?.length">
            <hr *ngIf="confirmedSpeakers.length || reps.length" class="person-divider" />
            <div class="people-subheader">Host</div>
            <ng-container *ngFor="let host of event.hosts; let last = last">
              <div class="person-card">
                <div class="person-photo-wrapper">
                  <img *ngIf="host.photo" [src]="host.photo" [alt]="fullSpeakerName(host)" class="person-photo" />
                  <div *ngIf="!host.photo" class="person-photo-placeholder">
                    {{ (host.first_name || '').charAt(0) }}{{ (host.last_name || '').charAt(0) }}
                  </div>
                </div>
                <div class="person-info">
                  <span class="person-name">{{ fullSpeakerName(host) }}</span>
                  <span class="person-title" *ngIf="host.title">{{ host.title }}</span>
                  <span class="person-role">Host</span>
                </div>
              </div>
              <hr *ngIf="!last" class="person-divider" />
            </ng-container>
          </ng-container>

          <!-- Attendee Search (hidden when the event has concluded) -->
          <ng-container *ngIf="!isEventConcluded">
            <hr *ngIf="(confirmedSpeakers.length || reps.length || event.hosts?.length) && attendeesLoaded" class="person-divider" />
            <div class="people-subheader">Attendee Search</div>

            <form [formGroup]="searchForm" class="attendee-search">
              <input type="text" formControlName="first_name" placeholder="First name" />
              <input type="text" formControlName="last_name" placeholder="Last name" />
              <input type="text" formControlName="city" placeholder="City" />
              <select formControlName="state">
                <option value="">State</option>
                <option *ngFor="let s of usStates" [value]="s.code">{{ s.name }}</option>
              </select>
            </form>

            <ng-container *ngIf="attendeesLoaded">
              <ng-container *ngFor="let result of displayedResults; let last = last">
                <div class="person-card person-card--clickable"
                     [class.person-card--current]="searchAllResults && result._source === 'attendee'"
                     (click)="selectSearchResult(result)">
                  <div class="person-photo-wrapper">
                    <div class="person-photo-placeholder">{{ attendeeInitials(result) }}</div>
                  </div>
                  <div class="person-info">
                    <span class="person-name">{{ attendeeDisplayName(result) }}</span>
                    <span class="person-title" *ngIf="attendeeSublabel(result)">{{ attendeeSublabel(result) }}</span>
                  </div>
                  <span class="person-current-badge"
                        *ngIf="searchAllResults && result._source === 'attendee'">On this event</span>
                </div>
                <hr *ngIf="!last" class="person-divider" />
              </ng-container>

              <div class="signin-search-all-row">
                <button type="button"
                        class="btn btn-outlined signin-search-all-btn"
                        [disabled]="!canSearchAll || searchAllInProgress"
                        (click)="searchAllContacts()">
                  {{ searchAllInProgress ? 'Searching...' : 'Search All Contacts' }}
                </button>
                <button type="button"
                        *ngIf="canCreateNewProfile"
                        class="btn btn-primary signin-search-all-btn"
                        (click)="createNewProfile()">
                  Create New Profile
                </button>
              </div>
            </ng-container>
          </ng-container>
        </section>

        <!-- ===== Sign-in form view ===== -->
        <section class="signin-form-section" *ngIf="view === 'signin'">
          <div class="signin-form-header">
            <h2 class="section-title" style="margin: 0;">
              {{ attendeeDisplayName(callPlan) || 'Sign In' }}
            </h2>
            <button type="button" class="signin-back-link" (click)="backToPeople()">&larr; Back</button>
          </div>
          <p class="signin-note">
            Please review your information below, answer the questions, sign your name in the space provided and click <b>Submit</b> when finished.
          </p>

          <form #attendeeForm="ngForm" (ngSubmit)="onSubmit(attendeeForm)">
            <div class="signin-form-grid">
              <div class="signin-form-col">
                <div class="form-group">
                  <label class="form-label">First Name:</label>
                  <input type="text" [(ngModel)]="callPlan.first_name" name="first_name" />
                </div>
                <div class="form-group">
                  <label class="form-label">Middle Name:</label>
                  <input type="text" [(ngModel)]="callPlan.middle_name" name="middle_name" />
                </div>
                <div class="form-group">
                  <label class="form-label">Last Name:</label>
                  <input type="text" [(ngModel)]="callPlan.last_name" name="last_name" />
                </div>
                <div class="form-group">
                  <label class="form-label">Affiliation:</label>
                  <input type="text" [(ngModel)]="callPlan.affiliation" name="affiliation" />
                </div>
                <div class="form-group">
                  <label class="form-label">Address 1:</label>
                  <input type="text" [(ngModel)]="callPlan.address1" name="address1" />
                </div>
                <div class="form-group">
                  <label class="form-label">Address 2:</label>
                  <input type="text" [(ngModel)]="callPlan.address2" name="address2" />
                </div>
                <div class="form-group">
                  <label class="form-label">City:</label>
                  <input type="text" [(ngModel)]="callPlan.city" name="city" />
                </div>
                <div class="form-group">
                  <label class="form-label">State / Zip:</label>
                  <div class="signin-row signin-row--state-zip">
                    <select name="state" [(ngModel)]="callPlan.state">
                      <option value="">State</option>
                      <option *ngFor="let s of usStates" [value]="s.code">{{ s.name }}</option>
                    </select>
                    <input type="text" [(ngModel)]="callPlan.zip" name="zip" placeholder="ZIP" />
                  </div>
                </div>
              </div>

              <div class="signin-form-col">
                <div class="form-group">
                  <label class="form-label">HCP Type:</label>
                  <select name="hcp_type" [(ngModel)]="callPlan.hcp_type">
                    <option value="">Select...</option>
                    <option *ngFor="let hcpType of hcpTypes" [value]="hcpType.label">{{ hcpType.label }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label" for="specialties">Specialty:</label>
                  <select name="specialty" [(ngModel)]="callPlan.specialty">
                    <option value="">Select...</option>
                    <option *ngFor="let item of attendeeSpecialities" [value]="item.value">
                      {{ item.value }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Vendor Code:</label>
                  <input type="text" [(ngModel)]="callPlan.vendor_code" name="vendor_code" />
                </div>
                <div class="form-group">
                  <label class="form-label">NPI #:</label>
                  <input type="text" [(ngModel)]="callPlan.npi_id" name="npi_id" />
                </div>
                <div class="form-group">
                  <label class="form-label">License # / State:</label>
                  <div class="signin-row signin-row--license">
                    <input type="text" [(ngModel)]="callPlan.state_license_number" name="state_license_number" />
                    <select name="license_state" [(ngModel)]="callPlan.license_state">
                      <option value="">State</option>
                      <option *ngFor="let s of usStates" [value]="s.code">{{ s.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form-label">Telephone:</label>
                  <input type="tel" [(ngModel)]="callPlan.cell_phone" name="cell_phone" />
                </div>
                <div class="form-group">
                  <label class="form-label">RSVP Email:</label>
                  <input type="email" [(ngModel)]="callPlan.email" name="email" />
                </div>
                <div class="form-group">
                  <label class="form-label">Credentials:</label>
                  <input type="text" [(ngModel)]="callPlan.degree" name="degree" />
                </div>
              </div>
            </div>

            <div class="form-group signin-meal-opt">
              <p><b>If you elect NOT to consume provided Food and Beverage, please indicate as such:</b></p>
              <label class="signin-check-label">
                <input type="checkbox" [(ngModel)]="callPlan.meal_opt_out" name="meal_opt_out" />
                I elect NOT to consume the provided Food or Beverage.
              </label>
            </div>

            <div class="form-group">
              <label class="form-label">Signature:</label>
              <app-signature-field name="signature" [(ngModel)]="callPlan.signature"></app-signature-field>
              <button type="button"
                      class="btn btn-outlined signin-clear-btn"
                      (click)="clearSignature()"
                      [disabled]="!callPlan.signature">
                Clear Signature
              </button>
            </div>

            <div class="signin-submit-row">
              <button type="submit"
                      class="btn btn-primary"
                      [disabled]="!attendeeForm.form.valid || submitting">
                {{ submitting ? 'Submitting...' : 'Submit' }}
              </button>
            </div>
          </form>
        </section>

        <!-- ===== Evaluation view ===== -->
        <section class="signin-form-section" *ngIf="view === 'evaluation'">
          <div class="signin-form-header">
            <h2 class="section-title" style="margin: 0;">Evaluation</h2>
          </div>
          <p class="signin-note">Please complete the brief evaluation below and click <b>Submit</b> when finished.</p>

          <div class="signin-eval-loading" *ngIf="evalLoading">Loading evaluation...</div>

          <form #evaluationForm="ngForm" (ngSubmit)="onSubmitEvaluation(evaluationForm)" *ngIf="!evalLoading && evalQuestions.length">
            <ng-container *ngFor="let eq of evalQuestions">
              <div class="form-group signin-eval-question" *ngIf="eq?.question">
                <!-- HEADER -->
                <h4 *ngIf="getQuestionTypeId(eq.question) === 'HEADER'" class="signin-eval-header">{{ eq.question.text }}</h4>

                <!-- PARAGRAPH -->
                <p *ngIf="getQuestionTypeId(eq.question) === 'PARAGRAPH'" class="signin-eval-paragraph">{{ eq.question.text }}</p>

                <!-- Shared label template for input questions -->
                <ng-template #evalLabel let-eq="eq">
                  <label class="form-label signin-eval-label">
                    <span *ngIf="eq.question.always_required" class="required-marker">*</span>
                    <span *ngIf="eq._displayNumber">{{ eq._displayNumber }}.</span>
                    {{ eq.question.text }}
                  </label>
                </ng-template>

                <!-- TEXT_FIELD -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'TEXT_FIELD'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <input type="text"
                         [name]="'q_' + eq.question.id"
                         [(ngModel)]="evalAnswers[eq.question.id]"
                         [required]="!!eq.question.always_required" />
                </ng-container>

                <!-- COMMENTS -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'COMMENTS'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <textarea rows="3"
                            [name]="'q_' + eq.question.id"
                            [(ngModel)]="evalAnswers[eq.question.id]"
                            [required]="!!eq.question.always_required"></textarea>
                </ng-container>

                <!-- DROPDOWN -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'DROPDOWN'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <select [name]="'q_' + eq.question.id"
                          [(ngModel)]="evalAnswers[eq.question.id]"
                          [required]="!!eq.question.always_required">
                    <option value="">Select...</option>
                    <option *ngFor="let choice of getQuestionChoices(eq.question)" [value]="choice">{{ choice }}</option>
                  </select>
                </ng-container>

                <!-- MULTIPLE_RADIO -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'MULTIPLE_RADIO'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <div class="signin-eval-radio-group">
                    <label *ngFor="let choice of getQuestionChoices(eq.question)" class="signin-check-label">
                      <input type="radio"
                             [name]="'q_' + eq.question.id"
                             [value]="choice"
                             [(ngModel)]="evalAnswers[eq.question.id]"
                             [required]="!!eq.question.always_required" />
                      {{ choice }}
                    </label>
                  </div>
                </ng-container>

                <!-- MULTIPLE_CHECK -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'MULTIPLE_CHECK'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <div class="signin-eval-check-group">
                    <label *ngFor="let choice of getQuestionChoices(eq.question)" class="signin-check-label">
                      <input type="checkbox"
                             [checked]="isChoiceSelected(eq.question.id, choice)"
                             (change)="onMultiCheckChange(eq.question.id, choice, $event)" />
                      {{ choice }}
                    </label>
                  </div>
                </ng-container>

                <!-- YN -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'YN'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <div class="signin-eval-radio-group">
                    <label class="signin-check-label">
                      <input type="radio" [name]="'q_' + eq.question.id" value="Yes" [(ngModel)]="evalAnswers[eq.question.id]" [required]="!!eq.question.always_required" /> Yes
                    </label>
                    <label class="signin-check-label">
                      <input type="radio" [name]="'q_' + eq.question.id" value="No" [(ngModel)]="evalAnswers[eq.question.id]" /> No
                    </label>
                  </div>
                </ng-container>

                <!-- TF -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'TF'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <div class="signin-eval-radio-group">
                    <label class="signin-check-label">
                      <input type="radio" [name]="'q_' + eq.question.id" value="True" [(ngModel)]="evalAnswers[eq.question.id]" [required]="!!eq.question.always_required" /> True
                    </label>
                    <label class="signin-check-label">
                      <input type="radio" [name]="'q_' + eq.question.id" value="False" [(ngModel)]="evalAnswers[eq.question.id]" /> False
                    </label>
                  </div>
                </ng-container>

                <!-- RATING -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'RATING'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <div class="signin-eval-stars" role="radiogroup" [attr.aria-label]="eq.question.text">
                    <button type="button"
                            *ngFor="let n of ratingScale()"
                            class="signin-eval-star"
                            [class.signin-eval-star--active]="getRating(eq.question.id) >= n"
                            (click)="setRating(eq.question.id, n)"
                            [attr.aria-label]="'Rate ' + n + ' of 5'">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </button>
                  </div>
                  <input type="hidden"
                         [name]="'q_' + eq.question.id"
                         [(ngModel)]="evalAnswers[eq.question.id]"
                         [required]="!!eq.question.always_required" />
                </ng-container>

                <!-- SIGNATURE -->
                <ng-container *ngIf="getQuestionTypeId(eq.question) === 'SIGNATURE'">
                  <ng-container *ngTemplateOutlet="evalLabel; context: { eq: eq }"></ng-container>
                  <app-signature-field [name]="'q_' + eq.question.id" [(ngModel)]="evalAnswers[eq.question.id]"></app-signature-field>
                </ng-container>
              </div>
            </ng-container>

            <div class="signin-submit-row">
              <button type="submit"
                      class="btn btn-primary"
                      [disabled]="!evaluationForm.form.valid || evalSubmitting">
                {{ evalSubmitting ? 'Submitting...' : 'Submit' }}
              </button>
            </div>
          </form>
        </section>

        <!-- ===== Thank-you view ===== -->
        <section class="signin-form-section signin-thankyou" *ngIf="view === 'thankyou'">
          <h2 class="section-title">Thank you for your participation!</h2>
          <div class="signin-submit-row">
            <button type="button" class="btn btn-primary" (click)="finishThankYou()">Done</button>
          </div>
        </section>

      </div><!-- /event-col-right -->
    </div><!-- /event-content-grid -->
  </div><!-- /page-wrapper -->
</div>
